import "./index.css";
import Textarea from "../../../layout/Textarea/Textarea";
import {useEdits} from "../../../contexts/edits";
import {useSetting} from "../../../contexts/setting";
import {useImages} from "../../../contexts/images";
import BgTransformer from "../../../layout/BgTransformer";
import adsAssets from "../../../data/ads-assets.json";

/**
 * EmailSmallAds — 650×200 email banner. Figma source: 1429:929.
 * Same content as BlogPostAds, narrower email format. Group 2 union is
 * flattened in Figma; tail SVG is a SoMe-scaled approximation.
 */
const EmailSmallAds = ({id, zoom}) => {
  const {channel, product, type, bgOption, locked} = useSetting();
  const {customBgs} = useImages();
  const isLocked = locked.some((x) => x === id);
  const customBgUrl = (isLocked ? customBgs[id] : undefined) || customBgs.main || null;
  const {titles, subtitles} = useEdits();
  const title = titles[id] || titles.main;
  const subtitle = subtitles[id] || subtitles.main;

  const bgIdx = bgOption || 1;
  const assetKey = `${channel.value}/${product.value}/${type.value}/${bgIdx}/${id}`;
  const bgUrl = adsAssets[assetKey]?.url;

  return (
    <div id={id} className={`template ${type.value} tpl-card`} style={{"--zoom-level": zoom}}>
      <div className="tpl-card__inner">
        {customBgUrl || bgUrl ? <BgTransformer src={customBgUrl || bgUrl} id={id} /> : null}
        <div className="tpl-bubble">
          <h2 className="subtitle">
            <Textarea id={id} text={subtitle} />
          </h2>
          <svg
            className="tpl-bubble__tail"
            viewBox="0 0 20.51 23.46"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <defs>
              <linearGradient
                id="EmailSmallAds-tail-gradient"
                gradientUnits="userSpaceOnUse"
                x1="5.30"
                y1="-39.91"
                x2="198.31"
                y2="19.27"
              >
                <stop offset="0" stopColor="#211104" />
                <stop offset="1" stopColor="#472407" />
              </linearGradient>
            </defs>
            <path
              d="M0 23.3C0 23.3 5.3 9.18 5.3 0L20.51 11.04C12.96 19.92 0 23.3 0 23.3Z"
              fill="url(#EmailSmallAds-tail-gradient)"
            />
          </svg>
        </div>
        <h1 className="title">
          <Textarea id={id} text={title} />
        </h1>
      </div>
    </div>
  );
};

export default EmailSmallAds;
